const highlights = [
  { icon: "ri-hospital-line", title: "Radiografia no local", desc: "Exames rápidos e diagnóstico imediato sem precisar sair da clínica." },
  { icon: "ri-tools-line", title: "Laboratório próprio de prótese", desc: "Próteses feitas internamente com agilidade e qualidade garantida." },
  { icon: "ri-speed-line", title: "Atendimento ágil", desc: "Estrutura otimizada para você ser atendido sem longas esperas." },
  { icon: "ri-team-line", title: "Equipe humanizada", desc: "Dentistas acolhedores que tratam cada paciente com atenção especial." },
];

export default function AboutSection() {
  return (
    <section id="sobre" className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Image */}
          <div className="relative mb-10 md:mb-0">
            <div className="rounded-2xl overflow-hidden w-full h-64 md:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/b1e55c91216005a0731bdc8e79673a02.jpg"
                alt="Equipe Primor Odontologia"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Badge */}
            <div className="absolute bottom-3 right-3 md:-bottom-6 md:-right-6 bg-primary-700 text-white rounded-2xl px-4 md:px-6 py-3 md:py-4">
              <p className="text-2xl md:text-3xl font-extrabold">+15k</p>
              <p className="text-xs md:text-sm text-white/80">Pacientes felizes</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-secondary font-semibold text-sm uppercase tracking-widest">Sobre a Clínica</span>
            <h3 className="text-2xl md:text-4xl font-extrabold text-primary-700 mt-3 mb-5 md:mb-6 leading-tight">
              Saúde bucal acessível para toda a família
            </h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
              A <strong>Primor Odontologia e Saúde Integrada</strong> nasceu com um propósito simples: oferecer tratamento dentário de alta qualidade a quem precisa, sem barreiras financeiras. Acreditamos que sorrir com saúde é um direito de todos.
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6 md:mb-8">
              Nossa clínica combina tecnologia moderna, equipe especializada e pagamento acessível para garantir que você comece seu tratamento hoje mesmo — com aprovação de crédito na hora e parcelamento facilitado.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {highlights.map((h) => (
                <div key={h.title} className="flex items-start gap-3 bg-primary-50 rounded-xl p-3 md:p-4">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-700 rounded-lg text-white flex-shrink-0">
                    <i className={`${h.icon} text-lg md:text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-primary-700 text-sm">{h.title}</p>
                    <p className="text-gray-500 text-xs mt-1 leading-relaxed">{h.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
